import request from '@/utils/request'

//实时天气
export function getWeatherNow() {
  return request({
    url: '/weather/now',
    method: 'get'
  })
}

//逐小时预报(未来24小时)
export function getWeatherHours(hours) {
    return request({
      url: `/weather/${hours}h`,
      method: 'get'
    })
}

/**
 * 逐天天气预报
 * @param {*} days 未来days天天气预报
 * @returns 
 * e.g https://api.qweather.com/v7/weather/3d?
 */
export function getWeatherDays(days){
  return request({
    url:`/weather/${days}d`,
    method:'get'
  })
}

//空气质量
export function getAirNow(){
  return request({
    url:'/air/now',
    method:'get'
  })
}

//灾害预警
export function getWarningNow(){
  return request({
    url:'/warning/now',
    method:'get'
  })
}